import React, { Component } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import ResponsiveImage from "../../Shared/ResponsiveImage/responsive-image";

class HeroRichText extends Component {
    render() {
        const baseClass = "hero-rich-text";
        const rootClasses = classNames(baseClass, "content-module", {
            [`${baseClass}--has-image`]: this.props.ImageSrc,
            [`${baseClass}--has-bg-color`]: this.props.BackgroundColor,
            [`${baseClass}--is-direction-flipped`]: this.props.FlipImageAndText,
            [`${this.props.BackgroundColor}--bg`]: this.props.BackgroundColor,
            [`${this.props.TextColor}--text`]: this.props.TextColor
        });
        const gradientClasses = classNames(`${baseClass}__gradient`, {
            [`${this.props.BackgroundColor}--text`]: this.props.BackgroundColor
        });

        return (
            <div className={rootClasses}>
                <div className={`${baseClass}__content-wrapper`}>
                    <div className={`${baseClass}__content`}>
                        <div className={`${baseClass}__content-inner`}>
                            {this.props.Trumpet && (
                                <div
                                    className={`${baseClass}__trumpet`}
                                    dangerouslySetInnerHTML={{ __html: this.props.Trumpet }}
                                />
                            )}
                            {this.props.Title && (
                                <h1 className={`${baseClass}__title`}>
                                    <span dangerouslySetInnerHTML={{ __html: this.props.Title }} />
                                </h1>
                            )}
                            {this.props.RichText && (
                                <div
                                    className={`${baseClass}__subtext content-rich-text`}
                                    dangerouslySetInnerHTML={{ __html: this.props.RichText }}
                                />
                            )}
                            {this.props.Link && (
                                <div
                                    className={`${baseClass}__cta`}
                                    dangerouslySetInnerHTML={{ __html: this.props.Link }}
                                />
                            )}
                        </div>
                        {!this.props.NoGradient && <div className={gradientClasses}></div>}
                    </div>
                </div>
                {this.props.ImageSrc && (
                    <div className={`${baseClass}__picture-wrapper`}>
                        <div className={`${baseClass}__picture`}>
                            <ResponsiveImage
                                srcUrl={this.props.ImageSrc}
                                defaultSize={800}
                                srcSetSizes={[375, 450, 640, 768, 1024, 1280, 1440, 1920]}
                                sizes="(max-width: 1240px) 100vw, calc(100vw - 300px)"
                                alt=""
                            />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

HeroRichText.proptypes = {
    ImageSrc: PropTypes.string,
    Trumpet: PropTypes.string,
    Title: PropTypes.string,
    RichText: PropTypes.string,
    Link: PropTypes.string,
    BackgroundColor: PropTypes.string,
    TextColor: PropTypes.string,
    NoGradient: PropTypes.bool,
    FlipImageAndText: PropTypes.bool
};

export default HeroRichText;
